import React from 'react';
import { Modal, ModalBody, Button, Form, ModalHeader } from 'reactstrap';
import * as EmployeeAction from 'store/actions/employee';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { fetchInvoiceNumber } from 'services/depositInvoice';
import BasicInfoForm from './../basicInfoForm';
import ItemInfoForm from './../itemInfoForm';
import AdressInputForm from 'pages/information/addressbook/inputForm';
import './add-dialog.scss';
import { t } from 'i18next';
import { NotificationManager } from 'react-notifications';

export default function AddDialog({ modalOpen, onToggle, onSubmit, editData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      items: [
        {
          itemname: '',
          unit: '',
          qty: 1,
          amount: '',
          remark: '',
        },
      ],
    },
  });



  const submitData = async (values) => {
    if (editData) {
      values.isEdit =true;
    }
    onSubmit(values);
  };

  const [selectedAddress, setSelectedAddress] = React.useState(null);

  const dispatch = useDispatch();
  const countries = useSelector((state) => state.location.countries);

  React.useEffect(() => {
    if (editData) {
      setValue('basicinfo.invoice_no', editData?.invoice_number);
      setValue('basicinfo.quotation_no', editData?.quotation_no);
      setValue('basicinfo.dil_no', editData?.dil_no);
      setValue('basicinfo.invoice_date', editData?.invoice_date);
      setValue('basicinfo.currency', editData?.currency || 'MMK');
      setValue('basicinfo.destination',editData?.destination?._id)
      setValue('costinfo.paymentType', editData?.paymentType?._id);
      
      // Set items array if exists
      if (editData?.items && editData.items.length > 0) {
        setValue('items', editData.items);
      }

      setValue('senderinfo', editData.sender);
      setValue('senderinfo.code', editData.address_code);
     

      setValue('receiverinfo', editData.receiver);

     
      setSelectedAddress({branch:{name:editData?.destination?.name},marketing_person:{name:editData?.sale_person?.name}})
    } else {
      reset({
        items: [
          {
            itemname: '',
            unit: '',
            qty: 1,
            amount: '',
            remark: '',
          },
        ],
      });
    }
  }, [editData, getValues, reset, setValue]);

  React.useEffect(() => {
    dispatch(EmployeeAction.getMarketingPerson());
  }, [dispatch, EmployeeAction.getMarketingPerson]);

  const onFetchInvoiceNumber = async () => {
    const response = await fetchInvoiceNumber();
    if (response) {
      setValue('generated_invoice_number', response);
      setValue('basicinfo.invoice_no', response.invoice_number);
    }
  };

  return (
    <Modal
      isOpen={modalOpen}
      size='lg'
      style={{
        maxWidth: '1400px',
        width: '80%',
        minWidth: 400,
      }}
      backdrop={true}
    >
      {editData && (
        <ModalHeader style={{ background: '#e9e9ef' }}>
          <div>
            <h3>Invoice Number : {editData.invoice_number}</h3>
          </div>
        </ModalHeader>
      )}
      <ModalBody
        style={{
          maxHeight: '85vh',
          overflowY: 'auto',
        }}
      >
        <Form onSubmit={handleSubmit(submitData)} className='order-modal'>
          <BasicInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            editData={editData}
            watch={watch}
            selectedAddress={selectedAddress}
            onFetchInvoiceNumber={onFetchInvoiceNumber}
          />

          <div className='divider'></div>
          <AdressInputForm
            register={register}
            errors={errors}
            control={control}
            options={{ countries: countries }}
            editData={editData}
            addNew={false}
            setValue={setValue}
            types={['senderinfo', 'receiverinfo']}
            getValues={getValues}
            onSelectAddress={(address) => {
              setSelectedAddress(address);
            }}
            noCard={true}
          />
          <div className='divider'></div>
          <ItemInfoForm
            register={register}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            editData={editData}
            getValues={getValues}
          />
          <div className='custom-modal-footer'>
            <Button color='success' type='button' onClick={() => onToggle(!modalOpen)}>
              {t('cancel')}
            </Button>
            <Button color='primary' type='submit'>
              {t('submit')}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}
